module.exports = __webpack_public_path__ + "static/media/oily_non_sensitive.0d0bc5b6.png";